import React, { useState } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5001';

function Login({ onLogin }) {
  const [token, setToken] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const validateToken = async (token) => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/user`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Token validation error:', error);
      throw new Error(error.response?.data?.error || 'Invalid token');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      if (!token.trim()) {
        throw new Error('Please enter a GitHub token');
      }

      // Validate the token by making a test API call
      await validateToken(token.trim());

      // If validation succeeds, call onLogin
      onLogin(token.trim());
      navigate('/dashboard');
    } catch (error) {
      setError(error.message || 'Failed to validate token');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <Card style={{ width: '400px' }}>
        <Card.Header className="bg-primary text-white">
          <h3 className="mb-0">GitHub Repository Manager</h3>
        </Card.Header>
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>GitHub Personal Access Token</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter your GitHub token"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                required
                disabled={isLoading}
              />
              <Form.Text className="text-muted">
                Enter your GitHub personal access token with the following scopes: repo, user, read:org, workflow
              </Form.Text>
            </Form.Group>

            <div className="d-grid gap-2">
              <Button 
                variant="primary" 
                type="submit"
                disabled={isLoading || !token.trim()}
              >
                {isLoading ? 'Validating...' : 'Login'}
              </Button>
            </div>

            <div className="mt-3">
              <h6>How to get a GitHub token:</h6>
              <ol className="small">
                <li>Go to GitHub Settings → Developer settings → Personal access tokens → Tokens (classic)</li>
                <li>Click "Generate new token (classic)"</li>
                <li>Add a note (e.g., "GitHub Repo Manager")</li>
                <li>Select scopes: repo, user, read:org, workflow</li>
                <li>Click "Generate token"</li>
                <li>Copy and paste the token here</li>
              </ol>
              <Alert variant="warning" className="mt-2 mb-0">
                Note: Store your token securely. You won't be able to see it again on GitHub.
              </Alert>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Login;
